import Flickity from 'flickity';
import 'flickity/dist/flickity.min.css';
import { gsap } from 'gsap';

/**
 * Rooms Carousel Component
 * Handles the rooms carousel on the homepage with:
 * - Two images per slide (50/50 split)
 * - Green cover reveal animation on slide change
 * - Staggered timing between image 1 and image 2
 */
export default class RoomsCarousel {
  constructor(element) {
    this.element = element;
    this.track = element.querySelector('.rooms-carousel-track');
    this.slides = Array.from(element.querySelectorAll('.rooms-carousel-slide'));
    this.prevBtn = element.querySelector('.carousel-prev');
    this.nextBtn = element.querySelector('.carousel-next');
    this.currentCounter = element.querySelector('.carousel-counter .current');
    this.totalCounter = element.querySelector('.carousel-counter .total');
    
    this.flickity = null;
    this.isAnimating = false;
    
    if (this.slides.length === 0) {
      console.warn('No slides found in rooms carousel');
      return;
    }
    
    this.init();
  }
  
  init() {
    // Set total counter
    if (this.totalCounter) {
      this.totalCounter.textContent = this.slides.length;
    }
    
    // Initialize Flickity with instant transitions (no slide animation)
    this.flickity = new Flickity(this.track, {
      cellAlign: 'center',
      cellSelector: '.rooms-carousel-slide',
      contain: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      adaptiveHeight: false,
      imagesLoaded: true,
      selectedAttraction: 1, // Instant positioning
      friction: 1, // Maximum friction for instant stop
      percentPosition: false,
    });
    
    // Bind custom navigation
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        if (!this.isAnimating) {
          this.flickity.previous();
        }
      });
    }
    
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        if (!this.isAnimating) {
          this.flickity.next();
        }
      });
    }
    
    // Update counter on slide change
    this.flickity.on('change', (index) => {
      this.updateCounter(index);
    });
    
    // Flickity adds .is-selected automatically, but ensure first slide is revealed
    this.flickity.on('ready', () => {
      const selectedSlide = this.track.querySelector('.is-selected');
      if (selectedSlide) {
        // Force a reflow to ensure transition works
        void selectedSlide.offsetHeight;
      }
    });
    
    // Initialize first slide
    this.updateCounter(0);
  }
  
  /**
   * Update the counter display
   */
  updateCounter(index) {
    if (this.currentCounter) {
      this.currentCounter.textContent = index + 1;
    }
  }
  
  /**
   * Destroy the carousel instance
   */
  destroy() {
    if (this.flickity) {
      this.flickity.destroy();
    }
  }
}
